// LabelWorkflowTableRow.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../utils/timeUtils';
import Avatar from './Avatar';
import StatusIndicator from './StatusIndicator';
import ActionButton from './ActionButton';
import { ApprovalStatus } from '../types';
import { useNavigateWithinProject } from '../utils/navigation';

// Define prop types
interface LabelWorkflowTableRowProps {
    label: any; // Replace with proper type from your types file
    labelThumbnailUrl: string;
    userDetailsMapping: Record<string, any>; // Replace with proper type
    project: any; // Replace with proper type
    userCanReview: (reviewerId: string) => boolean;
}

const LabelWorkflowTableRow: React.FC<LabelWorkflowTableRowProps> = ({
    label,
    labelThumbnailUrl,
    userDetailsMapping,
    project,
    userCanReview,
}) => {
    const navigate = useNavigateWithinProject();

    const reviewContentClass = (status: ApprovalStatus) => {
        if (status === ApprovalStatus.APPROVED) {
            return 'green';
        } else if (status === ApprovalStatus.REFERRED) {
            return 'yellow';
        } else if (status === ApprovalStatus.REJECTED) {
            return 'red';
        } else {
            return '';
        }
    };

    return (
        <tr className="label-row">
            <td className="label-column">
                <div
                    className="label-card"
                    onClick={() => navigate(`/labels/${label.id}`)}
                >
                    <div className="label-content">
                        <img src={labelThumbnailUrl} />
                        <div className="label-info">
                            <p className="version">{label.name}</p>

                            {label.notes && (
                                <p className="notes">{label.notes}</p>
                            )}

                            <div className="botton-container">
                                <Avatar
                                    userDetails={
                                        userDetailsMapping[
                                            label.creation.user_id
                                        ]
                                    }
                                    height={22}
                                />

                                <div className="date-container">
                                    <FontAwesomeIcon icon={faCalendar} />
                                    <p>
                                        {formatDate(label.creation.timestamp)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
            <td className="review-column">
                <div
                    className={`review-content ai-review ${reviewContentClass(
                        label.approval_status,
                    )}`}
                >
                    <StatusIndicator
                        decision={label.approval_status}
                        isBig={true}
                    />
                </div>
            </td>
            {project.workflow.stages.map((stage: any, i: number) => {
                const reviewedStage = label.reviewed_stages.find(
                    (rs: any) => stage.id === rs.id,
                );

                if (!reviewedStage)
                    return (
                        <td className="review-column" key={i}>
                            <div className="review-content empty"></div>
                        </td>
                    );

                const reviewer = userDetailsMapping[reviewedStage.user_id];
                const reviewerName = reviewer
                    ? `${reviewer.first_name} ${reviewer.last_name}`
                    : 'Unknown Reviewer';

                if (reviewedStage.status === 'Pending') {
                    return (
                        <td className="review-column" key={i}>
                            {userCanReview(reviewedStage.user_id) ? (
                                <div className="review-now">
                                    <ActionButton
                                        text="Review Now"
                                        onClick={() =>
                                            navigate(`/labels/${label.id}`)
                                        }
                                        className="branded"
                                        icon={faArrowRight}
                                    />
                                </div>
                            ) : (
                                <div className="review-content">
                                    <div className="upper-container">
                                        <StatusIndicator
                                            decision={reviewedStage.status}
                                            isBig={true}
                                        />
                                        <p className="reviewer">
                                            {' '}
                                            by {reviewerName}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </td>
                    );
                }

                return (
                    <td className="review-column" key={i}>
                        <div
                            className={`review-content ${reviewContentClass(
                                reviewedStage.status,
                            )}`}
                        >
                            <div className="upper-container">
                                <StatusIndicator
                                    decision={reviewedStage.status}
                                    isBig={true}
                                />
                                <p className="reviewer"> by {reviewerName}</p>
                            </div>

                            {reviewedStage.comment && (
                                <div className="comment-container">
                                    <p className="comment">
                                        {reviewedStage.comment}
                                    </p>
                                </div>
                            )}
                        </div>
                    </td>
                );
            })}
        </tr>
    );
};
export default LabelWorkflowTableRow;
